<template>
    <div>
        <div class="fixed-footer footer-content">
            <div>
                <img
                    src="@/assets/images/email-icon.svg"
                    alt=""
                    srcset=""
                    width="30"
                />
                <div class="social-content">
                    <a href="mailto: ir@jsil.com" target="_blank">
                        <p>Email</p>
                        <p>ir@jsil.com</p>
                    </a>
                </div>
            </div>
            <div>
                <img src="@/assets/images/call-icon.svg" width="30" />
                <div class="social-content">
                    <p>Toll Free Number</p>
                    <p>0800-00887</p>
                </div>
            </div>
            <div>
                <img src="@/assets/images/web-icon.svg" width="30" />
                <div class="social-content">
                    <a href="https://jsil.com/" target="_blank">
                        <p>Website</p>
                        <p>www.jsil.com</p></a
                    >
                </div>
            </div>
            <div>
                <div class="social-content follow">
                    <p style="">Follow us on social media</p>
                    <div class="icons" style="">
                        <a
                            href="https://www.youtube.com/channel/UC7iYwXZeW-BpBhdXzqAz0xw"
                            target="_blank"
                        >
                            <img src="@/assets/images/yt-icon.svg" />
                        </a>
                        <a
                            href="https://www.facebook.com/JSinvestments/"
                            target="_blank"
                        >
                            <img src="@/assets/images/fb-icon.svg" />
                        </a>
                        <a
                            href="https://www.instagram.com/js.investments/?hl=en"
                            target="_blank"
                            ><img src="@/assets/images/ig-icon.svg"
                        /></a>
                        <a
                            href="https://twitter.com/JSInvestment?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
                            target="_blank"
                            ><img src="@/assets/images/twitter-icon.svg"
                        /></a>
                        <a
                            href="https://www.linkedin.com/company/js-investments-limited/?originalSubdomain=pk"
                            target="_blank"
                        >
                            <img src="@/assets/images/in-icon.svg"
                        /></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>

<style>
</style>